import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

import bg_modal from "./assets/img/popup-bg.png";
import bonus_modal from "./assets/img/popup-bonuses.png";
import btn_modal from "./assets/img/popup-btn.png";

function Modal(props) {
	const xs = useMediaQuery({
		query: "(min-width: 0px) and (max-width: 767.98px)",
	});
	const md = useMediaQuery({
		query: "(min-width: 768px) and (max-width: 991.98px)",
	});
	const lg = useMediaQuery({
		query: "(min-width: 992px) and (max-width: 1169.98px)",
	});
	const xl = useMediaQuery({
		query: "(min-width: 1170px)",
	});
	const styles = {
		modal: {
			backgroundColor: "#0C1013",
			filter: "drop-shadow(0px 0px 53.3434px #D71015)",
			border: "10px solid #D71015",
			borderRadius: 10,
			position: "fixed",
			backgroundSize: "contain",
			height: xs ? 550 : 610,
			width: xs ? 320 : 592,
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			zIndex: 1000,
			title: {
				textAlign: "center",
				fontSize: xs ? 45 : 62,
				color: "#fff",
				textTransform: "uppercase",
				fontFamily: "Leon-Bold, sans-serif",
			},
			text: {
				fontFamily: "Uni Sans",
				fontStyle: "italic",
				fontWeight: 900,
				fontSize: xs ? 35 : 60,
				// lineHeight: "132px",
				textAlign: "center",
				color: "#FDC000",
			},
			img: {
				backgroundImage: `url(${bonus_modal})`,
				height: 210,
				width: 210,
			},
			btn: {
				padding: "10px 0",
				width: "90%",
				background:
					"linear-gradient(180deg, rgba(215, 16, 21, 0.8) 0%, #FF0006 46.14%, rgba(215, 16, 21, 0.79) 100%)",
				boxShadow: "0px 12px 15px rgba(0, 0, 0, 0.3)",
				fontFamily: "Uni Sans",
				fontStyle: "italic",
				fontWeight: 900,
				fontSize: xs ? 35 : 50,
				borderRadius: 10,
				cursor: "pointer",
				margin: "auto",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				color: "#fff",
				textTransform: "uppercase",
			},
		},
	};
	return (
		<div style={{ ...styles.modal, ...props.style }}>
			<div style={{ width: "100%" }}>
				<div style={styles.modal.title}>
					{props.type === 1 || props.type === 3 ? "Вы выиграли" : "Ничего..."}
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						marginTop: 40,
						marginBottom: 60,
						position: "relative",
					}}
				>
					{props.type === 3 ? (
						<>
							<div
								style={{
									...styles.modal.text,
									alignSelf: "flex-start",
									width: "50%",
								}}
							>
								100 000 тенге
							</div>
							<div
								style={{
									position: "absolute",
									left: "50%",
									top: "50%",
									transform: "translate(-50%, -50%)",
									fontFamily: "Uni Sans",
									fontStyle: "italic",
									fontWeight: 900,
									fontSize: 90,
									color: "#D71015",
								}}
							>
								+
							</div>
						</>
					) : null}
					{props.type === 1 || props.type === 3 ? (
						// <div style={{ ...styles.modal.img, backgroundPositionY: 0 }}></div>
						<div
							style={{
								...styles.modal.text,
								alignSelf: props.type === 1 ? "center" : "flex-end",
								width: props.type === 1 ? "100%" : "50%",
								marginRight: props.type === 1 ? 0 : 25,
							}}
						>
							10% кэшбека
						</div>
					) : null}
				</div>

				{/* <div
					style={{
						...styles.modal.btn,
					}}
					onClick={props.onHandlerClickModal}
				>
					{props.type === 1 || props.type === 2
						? "Крутить еще"
						: "Забрать бонус"}
				</div> */}
				<div
					style={styles.modal.btn}
					className={"modal-btn"}
					onClick={props.onHandlerClickModal}
				>
					{props.type === 1 || props.type === 2
						? "Крутить еще"
						: "Забрать бонус"}
				</div>
			</div>
		</div>
	);
}
export default Modal;
